export function resolvePortValue(value) {
    return value instanceof Observable ? value.value : value;
}
export class Observable {
    _value;
    _listeners = [];
    get value() {
        return this._value;
    }
    set value(newVal) {
        const oldVal = this._value;
        if (oldVal === newVal)
            return;
        this._value = newVal;
        this._listeners.forEach((fn) => fn(newVal, oldVal));
    }
    addOnChangeListener(listener) {
        this._listeners.push(listener);
    }
    removeOnChangeListener(listener) {
        const index = this._listeners.indexOf(listener);
        if (index >= 0) {
            this._listeners.splice(index, 1);
        }
    }
}
